import { Component, OnInit } from '@angular/core';
import { RegisterService } from 'src/app/core/services/register/register.service';
import { BusinessResponseDTO } from 'src/app/shared/models/dtos/register-form/business-response-dto/business-response-dto';
import { RoutesKeys } from 'src/app/utils/routes';

@Component({
  templateUrl: './confirmed-membership.page.html',
})
/**
 * Renders representative confirm template
 */
export class ConfirmedMembershipPage implements OnInit {
  RoutesKeys = RoutesKeys;
  newBusiness!: BusinessResponseDTO;

  /**
   * @constructor
   */
  constructor(private readonly registerService: RegisterService) {}

  /**
   * on init
   */
  ngOnInit() {
    this.newBusiness = this.registerService.inviteNewBusiness!;
    this.registerService.inviteNewBusiness = undefined;
  }
}
